import BaseRestService from './baseRestService';

const _serviceDependencies = ['$http', '$q', 'Util'];

/**
 * @ngdoc service
 * @name rest.services.ProfileImageRestService
 * @augments rest.services.BaseRestService
 *
 * @description
 * This class contains methods used to upload images
 * using http requests.
 */
class ProfileImageRestService extends BaseRestService {

    /**
     * @param  {any} $http
     * @param  {any} $q
     * @param  {any} Util
     */
    constructor($http, $q, Util) {

        super($http, $q, Util);

    }

    /**
     * @ngdoc function
     * @name rest.services.ProfileImageRestService#create
     * @methodOf rest.services.ProfileImageRestService
     * @function
     *
     * @description
     * This method will make a http request (POST) with image and user details
     * in order to upload the image to server.
     *
     * @param {object} imagePayload ProfileImage payload
     *
     * @returns {Promise} The promise of the call.
     */
    create(imagePayload) {

        return super.create(imagePayload, 'profile-image/');

    }

    /**
     * @ngdoc function
     * @name rest.services.ProfileImageRestService#remove
     * @methodOf rest.services.ProfileImageRestService
     * @function
     *
     * @description
     * Remove an image.
     *
     * @param {string} imageUrl Image identifier
     *
     * @returns {Promise} The promise of the call.
     */
    remove(imageUrl) {

        return super.remove(imageUrl, 'profile-image/');

    }

}

_serviceDependencies.push(ProfileImageRestService);

angular.module('rest.services')
    .service('ProfileImageRestService', _serviceDependencies);



// WEBPACK FOOTER //
// ./scripts/restServices/profileImageRestService.js